/**
 *
 * ClubControls
 *
 */

import React from 'react';
import PropTypes from 'prop-types';
// import styled from 'styled-components';
import { compose } from 'redux';
import { FormattedMessage } from 'react-intl';
import withUiControl from 'containers/UiControl/withUiControl';
import withLocations from 'containers/Locations/withEntity';
import Switch from 'components/Switch';
import Spinner from 'components/Spinner';

import messages from './messages';
import FilterClubs from './FilterClubs';

function ClubControls(props) {
  const { uiToggle, showLocations, locations } = props;
  return (
    <React-Fragment>
      <Spinner show={showLocations && locations.loading}>
        <Switch
          value={showLocations}
          onChange={uiToggle}
          id="show-clubs-switch"
        >
          <FormattedMessage {...messages.showLocations} />
        </Switch>
      </Spinner>
      <FilterClubs className={showLocations ? '' : 'hidden-low'} />
    </React-Fragment>
  );
}

ClubControls.propTypes = {
  showLocations: PropTypes.bool,
  locations: PropTypes.object,
  uiToggle: PropTypes.func.isRequired,
};

export default compose(
  withLocations,
  withUiControl('showLocations'),
)(ClubControls);
